<template>
  <v-select
    :items="yesNoList"
    item-value="value"
    item-text="name"
    :label="label"
    v-model="activeValue"
    :clearable="clearable"
    outlined
  ></v-select>
</template>

<script>
import { yesNoList } from '@/lib/enum/filters'

export default {
  props: [
    'active',
    'label',
    'clearable'
  ],
  data () {
    return {
      yesNoList
    }
  },
  computed: {
    activeValue: {
      get () {
        return this.active
      },
      set (newValue) {
        this.$emit('activeChange', newValue)
      }
    }
  }
}
</script>
